module.exports = __webpack_public_path__ + "img/nh3.f5d1a273.svg";